// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Khe0","right":"styles_right__ZZzhQ"};